// Default date shortcuts for date pickers

export const getSingleDateShortcuts = () => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return {
    today: {
      text: "Today",
      period: {
        start: new Date(),
        end: new Date()
      }
    },
    yesterday: {
      text: "Yesterday",
      period: {
        start: yesterday,
        end: yesterday
      }
    }
  };
};

export const getDateRangeShortcuts = () => {
  const now = new Date();
  const today = new Date(now);

  const last7Start = new Date(now);
  last7Start.setDate(now.getDate() - 6);

  const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);

  const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);

  const last3MonthsStart = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());

  return {
    last7days: {
      text: "Last 7 days",
      period: {
        start: last7Start,
        end: today
      }
    },
    thisMonth: {
      text: "This month",
      period: {
        start: thisMonthStart,
        end: new Date(today)
      }
    },
    lastMonth: {
      text: "Last month",
      period: {
        start: lastMonthStart,
        end: lastMonthEnd
      }
    },
    last3Months: {
      text: "Last 3 months",
      period: {
        start: last3MonthsStart,
        end: new Date(today)
      }
    }
  };
};
